module.exports = __webpack_public_path__ + "static/media/avatars_all_40.4970a47e.png";